import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApiClientError, adminLogin } from '@suangua/shared';

/**
 * 管理端登录页（M5，PLAN §6.3 / §6.5）
 * 提交 /api/admin/login（环境变量凭证，与用户账号完全独立）。
 * 视觉：墨色底 + 白卡 + 金色按钮（与用户端玄墨鎏金轻微呼应）。
 */
export function AdminLoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await adminLogin(username, password);
      navigate('/admin', { replace: true });
    } catch (err) {
      setError(err instanceof ApiClientError ? err.message : '登录失败');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-stone-100">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-stone-200 bg-white p-8 shadow-sm">
        <div className="flex items-center justify-center gap-2">
          <span className="grid h-9 w-9 -rotate-4 place-items-center rounded-lg bg-gradient-to-br from-red-500 to-red-700 text-base font-bold text-amber-50 shadow">
            卦
          </span>
          <div>
            <h1 className="text-base font-bold text-stone-800">算卦Lite 管理端</h1>
            <p className="text-[11px] text-stone-400">独立账号体系（环境变量凭证）</p>
          </div>
        </div>

        <div className="mt-6 space-y-3">
          <input
            className="w-full rounded-lg border border-stone-300 px-3 py-2 text-sm outline-none focus:border-amber-500 focus:ring-2 focus:ring-amber-100"
            placeholder="管理员用户名"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            className="w-full rounded-lg border border-stone-300 px-3 py-2 text-sm outline-none focus:border-amber-500 focus:ring-2 focus:ring-amber-100"
            type="password"
            placeholder="密码"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && <p className="text-xs text-red-500">{error}</p>}
          <button
            type="submit"
            disabled={submitting}
            className="w-full rounded-lg bg-gradient-to-b from-stone-700 to-stone-900 py-2 text-sm font-medium text-amber-50 transition-opacity hover:opacity-90 disabled:opacity-50"
          >
            <i className="fa-solid fa-right-to-bracket mr-1" />
            {submitting ? '登录中…' : '登录'}
          </button>
        </div>

        <p className="mt-5 text-center text-[11px] text-stone-300">仅限授权管理员访问 · 操作将被记录</p>
      </form>
    </div>
  );
}
